import service from "../../../services/purchase/ledgerAccount";
import { arrayPushOrUpdateByID } from './../../../utils/toolkit';


export default {
    namespaced: true,
    state: {
        list: [],
        loading: false
    },
    getters: {
        list: (state) => state.list,
        loading: (state) => state.loading
    },
    mutations: {
        setLoading: (state, payload) => state.loading = payload,
        push: (state, payload) => state.list = arrayPushOrUpdateByID(state.list, payload),
    },
    actions: {
        search(context, payload) {
            return new Promise((resolve, reject) => {
                context.commit("setLoading", true);
                service.search(payload).then(response => {
                    context.commit("push", response.data);
                    resolve(response);
                }).catch(error => {
                    reject(error);
                }).finally(() => {
                    context.commit("setLoading", false);
                });
            });
        },
        push(context, payload) {
            context.commit("push", [payload]);
        }
    }
}